import authRules from '../authRules';

const addAssignment = (user) => {
  const { scheduleData } = user.securityLevels;
  if (scheduleData >= authRules.addAssignment.scheduleData) {
    return true;
  } else {
    return false;
  }
}

export default addAssignment;



// WEBPACK FOOTER //
// ./src/AuthLogic/rules/addAssignment.js